<div mat-dialog-title class="dialog-info d-flex align-items-center horizontal-padding m-0">
  <label class="labelTitle">
    {{ data.header }}
  </label>
  @if (data.isConfirmative) {
  <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
  }
</div>

<mat-dialog-content class="dialog-content">
  <mat-icon>info</mat-icon>
  <span class="dialog-message">{{ data.message }}</span>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-raised-button color="primary" (click)="closeDialog()">
    {{ 'OK_BTN' | translate }}
  </button>
  @if (data.isConfirmative) {
  <button mat-raised-button color="warn" (click)="cancelDialog()">
    {{ 'CANCEL' | translate }}
  </button>
  }

</mat-dialog-actions>